import { useThemeMode } from "@/../_metronic/partials";

export function useThemeClassNames() {
	const { mode } = useThemeMode();

	const border = mode === "dark" ? "border-soft-dark-2px" : "border-soft-gray-2px";
	const background = mode === "dark" ? "background-soft-dark" : "background-soft-gray";

	return {
		border,
		background,
	};
}
